import { NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { environment } from '@env/environment';

import { WINDOW } from '@personal-area/common';
import { UserFacade } from '@personal-area/global/users/services';
import { SocialLink } from '@personal-area/global/social-authorization/models';
import { AuthService } from '@personal-area/global/authorization/services';
import { ClickOutsideModule } from '@personal-area/common';

@Component({
  selector: 'pac-footer-social-network-links',
  templateUrl: './footer-social-network-links.component.html',
  styleUrls: ['./footer-social-network-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgForOf, NgIf, NgTemplateOutlet, ClickOutsideModule],
})
export class FooterSocialNetworkLinksComponent {
  @Input()
  public socialNetworkLinks: SocialLink[] = [];

  public socialPopup = { wechat: false, line: false };

  constructor(
    private _authService: AuthService,
    private _sanitizer: DomSanitizer,
    private _cdr: ChangeDetectorRef,
    private _userFacade: UserFacade,
    @Inject(WINDOW) private _window: Window,
  ) {
  }

  public handleItemHref(item: SocialLink): string | SafeUrl {
    if (item.name === 'fb-msg' && this._authService.isLoggedIn) {
      return item.url + '?ref=' + environment.growthTool + '--' + this._userFacade.loggedUser.id;
    }
    return item.name ? this._sanitizer.bypassSecurityTrustUrl(item.url) : item.url;
  }

  public handleItemTarget(item: SocialLink): string {
    return ['fb-msg', 'telegram', 'viber'].includes(item.name) ? '_blank' : '_self';
  }

  public socialClick(event: any, item: string): void {
    if (item === 'wechat') {
      event.preventDefault();
      this.socialPopup.wechat = true;
    }

    if (item === 'line' && this._window.innerWidth >= 768) {
      event.preventDefault();
      this.socialPopup.line = true;
    }
    this._cdr.markForCheck();
  }

  public socialPopupClose(item: string): void {
    if (item in this.socialPopup) {
      this.socialPopup[item] = false;
      this._cdr.markForCheck();
    }
  }
}
